var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"px-3 py-1 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v(_vm._s(_vm.f_field.title))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7375bf52","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/EditFieldHeader.vue
// module id = DVzf
// module chunks = 1